export interface FeatureFlagsInterface {
  isCompanyCreationEnabled: boolean
}

export const features: FeatureFlagsInterface = {
  isCompanyCreationEnabled: false,
}
